<template>
  <div class="pl-2 pr-1">
    <sys-data-table
      :headers="GET_HEADERS"
      :items="GET_ITEMS"
      :height="alturaDaJanela - 198"
      :item-height="40"
      :search="search"
    >
      <template #top>
        <div class="d-flex align-center w-full pt-2 pb-1">
          <v-icon size="21" class="mr-1">mdi-format-list-bulleted</v-icon>
          <span class="font-18 font-weight-medium">Lista de Eventos</span>

          <v-spacer />

          <div class="mt-n5 w-450">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Pesquisar"
              single-line
              hide-details
              clearable
            />
          </div>

          <ConfiguracaoGeral class="mx-3" />

          <NovoEvento />
        </div>
      </template>

      <template #item.venda_prevista="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>
      <template #item.venda_realizada="{ value }">{{ Helpers.formatarValorMonetario(value) }}</template>

      <template #item.ativo="{ item }">
        <v-switch v-model="item.ativo" hide-details @click="ativarDesativarEvento(item)"/>
      </template>

      <template #item.porcentagem="{ value }">
        <v-progress-linear
          :value="value"
          height="25"
        >
          <strong>{{ Math.ceil(value) }}%</strong>
        </v-progress-linear>
      </template>

      <template #item.acoes="{ item }">
        <v-icon @click="abrirEditarEvento(item)">mdi-pencil</v-icon>
        <v-icon title="Configuração individual deste evento" @click="abrirConfiguracaoIndividual(item)">$StarCogOutline</v-icon>
      </template>
    </sys-data-table>

    <GraficoTabela />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Responsividade from '@/helpers/ResponsiveHeight';
import NovoEvento from './NovoEvento/Index.vue';
import GraficoTabela from '../GraficoTabela/Index.vue';
import ConfiguracaoGeral from '../ConfiguracaoGeral/Index.vue';

export default {
  mixins: [Responsividade],
  components: {
    NovoEvento,
    GraficoTabela,
    ConfiguracaoGeral
  },
  created() {
    this.buscarDados();
  },
  data: () => ({
    search: '',
  }),
  computed: {
    ...mapGetters({
      GET_HEADERS: 'EventoSazonalFinal/GET_HEADERS',
      GET_ITEMS: 'EventoSazonalFinal/GET_ITEMS',
    }),
  },
  methods: {
    buscarDados() {
      this.$store.dispatch('EventoSazonalFinal/buscarDadoInicial');
    },
    ativarDesativarEvento(item) {
      this.$store.dispatch('EventoSazonalFinal/ativarDesativarEvento', item);
    },
    abrirConfiguracaoIndividual(item) {
      this.$store.dispatch('EventoSazonalFinal/setFormNovoEvento', item);
      this.$store.dispatch('EventoSazonalFinal/setDialogConfiguracaoIndividual', true);
    },
    abrirEditarEvento(item) {
      this.$store.dispatch('EventoSazonalFinal/editarEvendoCriado', item);
    }
  }
}
</script>

<style>

</style>
